import { immerable } from "immer";
import { filtersTypeEnum } from "@sttedra_ui/framework";

import { tableViews, useSmallAddLabel } from "@/composables/_commons/helper.js";
import { workspacesList } from "@/api/workspaces/workspaces.api.js";

export default class WorkspacesTableConfig {
  [immerable] = true;

  constructor(buildModal, deleteRegister) {
    const fields = [
      {
        field: "titulo",
        label: "Título",
      },
      {
        field: "descripcion",
        label: "Descripción",
      },
      {
        field: "guidWorkspace",
        label: "GUID",
      },
      {
        field: "numeroInformes",
        label: "Nº Informes",
        sortable: false,
      },
    ];

    const advancedFilters = [
      {
        field: "titulo",
        label: "Título",
      },
      {
        field: "descripcion",
        label: "Descripción",
      },
      {
        field: "guidWorkspace",
        label: "GUID",
      },
    ];

    return {
      title: "Workspaces",
      api: workspacesList,
      schema: fields,
      actions: {
        header: [
          {
            label: useSmallAddLabel() ? "Añadir" : "Añadir workspace",
            icon: "add",
            command: () => buildModal(),
            extended: true,
          },
        ],
        item: [
          {
            label: "Editar",
            icon: "edit",
            command: (event) => buildModal(event),
            extended: false,
          },
          {
            label: "Borrar",
            icon: "delete",
            command: (event) => deleteRegister(event),
            extended: false,
            classObj: ["delete-action"],
            disabled: (event) => event.numeroInformes > 0,
          },
        ],
      },
      filters: [
        {
          type: filtersTypeEnum.GLOBAL,
          fields: advancedFilters,
        },
        {
          type: filtersTypeEnum.ADVANCED,
          fields: advancedFilters,
        },
      ],
      views: tableViews(),
    };
  }
}
